import type { ReactElement } from 'react';
import { useAgencyTypeOptions } from 'modules/core/useEnabledTypeOptions';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';

export function AgencyActivityTypesFilterChip({
  name = 'type',
  label,
  isMulti,
}: {
  name?: string;
  label?: string;
  isMulti?: boolean;
}): ReactElement {
  const options = useAgencyTypeOptions();
  return <SelectFilterChip name={name} label={label} options={options} isMulti={isMulti} />;
}
